import { classNames } from "src/helpers/classNames";

export const Loader2 = ({ size = "md", text = "Loading..." }) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  return (
    <div className="flex items-center justify-center p-3">
      <div className={classNames("animate-spin rounded-full border-2 border-gray-300 border-t-highlightColor", sizes[size])}></div>
      {text && <span className="ml-2 text-sm text-gray-500">{text}</span>}
    </div>
  );
};
